import { render, staticRenderFns } from "./userdetial.vue?vue&type=template&id=29cf691e&scoped=true"
import script from "./userdetial.vue?vue&type=script&lang=js"
export * from "./userdetial.vue?vue&type=script&lang=js"
import style0 from "./userdetial.vue?vue&type=style&index=0&id=29cf691e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf691e",
  null
  
)

export default component.exports